import React, { useEffect, useState } from "react";
import VideoSelfLearning from "./VideoSelfLearning";
import useSelfLearningContent from "./useSelfLearningContent";
import InstructionBlock from "../../Quiz/InstructionBlock/InstructionBlock";
import { ReactComponent as SelfLearningImage } from "../../../assets/images/no-pdf.svg";
import { useCourseContent, useStyles, useTranslations } from "examsbook-react-sdk/custom-hooks";
import { useTheme } from "../../../constants/themeProvider";
import { Box, Typography, useMediaQuery } from "@material-ui/core";
import { ReactComponent as Live } from "../../../assets/images/livecourse.svg";
import { ReactComponent as PointsIcon } from "../../../assets/images/points.svg";
import PropTypes from 'prop-types';
import CTabs from "../CTabs";
import SelfLearningCard from "../SelfLearningCard";
import LiveClassCard from "../LiveClassCard";
import QuizListSection from "../../QuizList/QuizListSection";
import { useDispatch } from "react-redux";
import CertificateCard from "../CertificateCard";
import NoData from "../../common/Nodata/noData";
import { useSelector } from "react-redux";
import moment from "moment";
import { getSelfLearningAction } from "examsbook-react-sdk/actions/getSelfLearningAction";
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useTheme as useMuiTheme } from "@material-ui/core/styles";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import LockIcon from '@material-ui/icons/Lock';
import { ReactComponent as GreenTick } from "../../../assets/images/greenTick.svg";
import { ColorsConstant } from "../../../constants/colorConstant";
import { setCourseProgress } from "examsbook-react-sdk/actions/getCourses";
import { courseCertificateListAction } from "examsbook-react-sdk/actions/certificateAddResponse";

function SelfLearningContent(props) {
  const { setSubmittedTest } = props;
  const theme = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const styles = {
    selfLearningImg: {
      '@media (max-width:959px)': {
        height: '18.3rem'
      } 
    },
    courseInfo: {
      borderRadius: '8px',
      padding: '24px',
      border: '1px solid #E9E9EB',
      marginBottom: '14px',
      background: ColorsConstant.white,
    },
    courseTitle: {
      color: '#1A1B1E',
      fontWeight: '600',
      fontSize: '20px',
      '@media (max-width: 767px)': {
        fontSize: 14
      },
      
    },
    courseText: {
      color: '#000000',
      fontWeight: '400',
      fontSize: '14px',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 4,
      overflow: 'hidden',
      display: '-webkit-box',
      margin: 0,
      '& > p': {
        fontSize: isMobile ?  '12px' : '14px',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 4,
        overflow: 'hidden',
        display: '-webkit-box',
        margin: 0,
      }
    },
    tagWrapper: {
      display: 'flex', 
      gap: '10px', 
      marginTop: 20,
    },
    alignCourseData: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 15
    },
    courseTags: {
      border:'1px solid #E7EBEE',
      color: theme?.primaryColor,
      display: 'flex',
      padding: '0px 9px',
      alignItems: 'center',
      borderRadius: '4px',
      cursor: 'default',
      fontSize: isMobile ? '12px' : '14px',
    },
    progressLayout: {
      borderRadius: '0px !important',
      backgroundColor: '#ffffff54',
      '& > div': {
        backgroundColor: '#FFFFFF !important'
      },
    },
    mainTabHeading: {
      margin: '30px 0px 10px 0px', 
      fontWeight: '500',
      '@media (max-width: 767px)': {
        fontSize: 16
      }
    },
    pointsBoxParent: {
      display: 'flex', alignItems: 'center',background: '#FFFDE7' , border: '1px solid #FFF176', borderRadius: '4px', padding: '0px 9px' 
    },
    pointsBoxAlign: {
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    },
    points1: {
      fontSize: isMobile ? '12px' : '14px', fontWeight: '600', paddingLeft: '4px', color: `${theme?.primaryColor}`
    },
    points2: {
      fontSize: isMobile ? '12px' : '14px', fontWeight: '600', color: '#FFB703'
    },
    expiringOnDiv: {
      display: 'flex', alignItems: 'center', gap: '5px'
    },
    expiringClockIcon: {
      fill: '#616161', height: '20px', width: '20px'
    },
    expiringOnText: {
      fontSize: isMobile ? '12px' : '14px', color: `${theme?.primaryColor}`
    },
    courseProgressDiv: {
      position: 'absolute', right: '24px', fontWeight: 500
    },
    mobileCourseProgressDiv: {
      marginTop: '16px', display: 'flex', justifyContent: 'space-between'
    },
    mobileCourseProgressText: {
      fontWeight: 500, fontSize: isMobile ? '12px' : '14px'
    },
    selfLearningtabsDiv: {
      border: !props?.showEvaluationTest ? "1px solid #E9E9EB" : 'none', borderRadius: "8px", paddingBottom: !props?.showEvaluationTest ? '14px' : 0, background: ColorsConstant.white
    },
    selfLearningScroll: {
      maxHeight:'calc(60dvh - 80px)', overflowY: 'auto'
    }
  }
  const classes = useStyles(styles)();
  const t = useTranslations();
  const {
    playerRef,
    defaultVideo,
    currentVideo,
    videoPlayback,
    setVideoPlayback,
    handleVideoPlayback,
    handleVideoOnReady,
    showPopup,
    closePopup,
    handleResume,
    handleStartFromBeginning,
    callProgressApi,
    videoPlayerControls,
    showComponent,
    toggleInstructionBox,
    startQuiz,
    quizIsStarted,
    isVideoLoaded,
    certificateUnlocked,
    isLoadingSelf,
  } = useSelfLearningContent(props);

  const [quiz, setQuiz] = useState([]);
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(null);
  const [refresh, setRefresh] = useState(true);
  const handleRefresh = () => setRefresh(!refresh);
  const { content } = useCourseContent(props?.selectedCourseId, props?.subject_id, props?.topic_id, refresh);
  const { data: courseDetail } = content;
  const [mySectionData, setMySectionData] = useState([]);
  const [quizAttemptsCount, setQuizAttemptsCount] = useState(0);
  const [certificateData, setCertificateData] = useState([]);
  const isCertCompleted = certificateData && certificateData?.isCompleted === true;

  const [currentActiveSection, setCurrentActiveSection] = useState(props?.activeItem?.data);
  const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);
  let learningData = useSelector((state) => state.selfLearningReducers);
  let selfLearningData = learningData.selfLearningData;

  useEffect(() => {
    if(!isLoadingSelf) {
      if (mySectionData && mySectionData?.data?.evaluationTest || selfLearningData?.data?.evaluationTest) {
          setQuiz(mySectionData?.data?.evaluationTest ? mySectionData?.data?.evaluationTest : selfLearningData?.data?.evaluationTest);
      } 
      // else {
      //     setQuiz([]);
      // }
    }
}, [courseDetail, mySectionData, isLoadingSelf]);

  useEffect (() => {
    if (props?.coursePercentage) {
      dispatch(setCourseProgress(props?.coursePercentage));
    }
  },[props?.coursePercentage])

  useEffect(() => {
    const quizAttemptsValue = settingsData?.data?.[0] ? settingsData?.data?.[0]?.customization?.quizAttempts : 3;
    setQuizAttemptsCount(quizAttemptsValue);
  },[settingsData]);

  useEffect(() => {
    getCourseSectionApiData();
  }, [props?.selectedCourseId, props?.videoRefresh, props?.pdfOpen, courseDetail]);


  const getCourseSectionApiData = async () => {
    try {
      if (props?.selectedCourseId && props?.selectedCourseId !== undefined) {
        dispatch(getSelfLearningAction(props?.selectedCourseId)).then((res) => {
            setMySectionData(res);
            if (!props.activeItem && typeof res != "undefined") {
                props.setActiveItem({
                  data:res?.data?.section[0],
                  sectionData:res
                });
            }
        });
      }
    } catch (error) {
        console.log('Error - ', error.message);
    }
  };

  useEffect(() => {
    if (mySectionData?.data?.courseId?._id) {
      dispatch(courseCertificateListAction(mySectionData?.data?.courseId?._id)).then((res) => {
        if (res?.data?.length) {
          setCertificateData(res?.data[0]);
        }
      });
    }
  }, [mySectionData?.data?.courseId?._id]);

  function LinearProgressWithLabel({ value = 0 }) {
  const overallProgress = Math.round(value);

  return (
    <Box width="100%" display="flex" alignItems="center" sx={{ gap: '10px' }}>
      {overallProgress <= 99 ? (
        <>
          <Box width={isMobile ? "18px" : "24px"}>
            <CircularProgressbar value={overallProgress} styles={{ path: { stroke: theme?.primaryColor, strokeWidth: '10px' } }}/>
          </Box>
          <Typography variant="inherit" sx={{ display: 'flex', color: '#000000DE' }}>
            {overallProgress}% {t('Completed')}
          </Typography>
        </>
      ) : (
        <Box style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
          <GreenTick/>
          <Typography variant="inherit" style={{color: '#2E7D32', fontWeight: '600'}}>{overallProgress}% {t('Completed')}</Typography>
        </Box>
      )}
    </Box>
  );
}


  LinearProgressWithLabel.propTypes = {
      value: PropTypes.number.isRequired,
  };

  if (!showComponent) {
    return null;
  }

  if (defaultVideo === undefined) {
    return (
      currentVideo?.refModel === "Quiz" ? (
        <InstructionBlock
          key={currentVideo?.contentData?._id || currentVideo?.contentData?.id || JSON.stringify(currentVideo?.contentData)}
          quiz={currentVideo?.contentData}
          quizIsStarted={quizIsStarted}
          toggleInstructionBox={toggleInstructionBox}
          startQuiz={startQuiz}
          certificateUnlocked={certificateUnlocked}
          courseName={props?.courseName}
          sectionId={props?.sectionId}
          setSubmittedTest={setSubmittedTest}
          setShowCourseModalAfterQuiz={props?.setShowCourseModalAfterQuiz}
          coursePercentage={props?.coursePercentage}
          setSuppressCourseModal={props?.setSuppressCourseModal}
          isCourseExpired={props?.isCourseExpired}
          neverExpired={props?.neverExpired}
        />
      ) : <SelfLearningImage alt="default-image" className={classes.selfLearningImg} style={{ width: "100%" }} />
    )
  }
  return (
    <Box>
    {
      props.showEvaluationTest || props.showInstructions ? <></> :  <Box className={classes.courseInfo}>
      <Box className={classes.alignCourseData}>
         <Typography className={classes.courseTitle} variant="h4">{props?.subjectDetail?.name || props?.courseName}</Typography>
        {!isMobile && !isLoadingSelf && <Box className={classes.expiringOnDiv}>
          {props?.activeItem?.sectionData?.completedOnDate && !props?.isCourseExpired ?
          <>
          <Box> <GreenTick style={{height: '16px', display: 'flex'}}/> </Box>
          <Typography className={classes.expiringOnText} style={{color: '#2e7d32'}} variant="h6">{`${t('Completed on')} ${moment(props?.activeItem?.sectionData?.completedOnDate).format("DD-MMM-YYYY")}`}</Typography>
          </> : props?.isCourseExpired ?
          <>
            <AccessTimeIcon className={classes.expiringClockIcon} style={{fill: '#d32f2f'}}/>
            <Typography className={classes.expiringOnText} style={{color: '#d32f2f'}} variant="h6">{`${t('Expired on')} ${moment(props?.activeItem?.sectionData?.assignedCourseEndDate).format("DD-MMM-YYYY")}`}</Typography>
          </>
          :
          <>
            <AccessTimeIcon className={classes.expiringClockIcon}/>
            <Typography className={classes.expiringOnText} variant="h6">{`${t('EXPIRING ON')} ${moment(props?.activeItem?.sectionData?.assignedCourseEndDate).format("DD-MMM-YYYY")}`}</Typography>
          </>
          }
        </Box>}
      </Box>
       <Typography className={classes.courseText} variant="h6" dangerouslySetInnerHTML={{ __html: props?.subjectDetail?.description || props?.courseDescription}}></Typography>
      <Box className={classes.tagWrapper}>
        {settingsData?.data?.[0]?.gamification?.enabled && settingsData?.data?.[0]?.gamification?.pointsEnabled && !props?.isCourseExpired && <Box className={classes.pointsBoxParent}>
            <Box className={classes.pointsBoxAlign}>
                <Box className={classes.pointsBoxAlign}><PointsIcon/></Box>
                <Typography variant='inherit' className={classes.points1}>{mySectionData?.userAwardedPoint}</Typography>
                <Typography variant='inherit' className={classes.points2}>/{mySectionData?.courseTotalPoints}</Typography>
            </Box>
        </Box>}
        {props?.subjectDetail?.isSelfLearning && <Box className={classes.courseTags}>{t('SELF LEARNING')}</Box>}
        {props?.subjectDetail?.isLive && <Box className={classes.courseTags}><span className='live-image'><Live/></span><span>{t('live')}</span></Box>}
        {!isMobile && <Box className={classes.courseProgressDiv}>
          <LinearProgressWithLabel value={props?.coursePercentage} />
        </Box>}
      </Box>
      {isMobile && 
        <Box className={classes.mobileCourseProgressDiv}>
          <Box className={classes.mobileCourseProgressText}>
            <LinearProgressWithLabel value={props?.coursePercentage} />
          </Box>
          <Box className={classes.expiringOnDiv}>
            {props?.isCourseExpired ?
            <><AccessTimeIcon className={classes.expiringClockIcon} style={{fill: '#d32f2f'}}/>
            <Typography className={classes.expiringOnText} style={{color: '#d32f2f'}} variant="h6">{`${t('Expired on')} ${moment(props?.activeItem?.sectionData?.assignedCourseEndDate).format("DD-MMM-YYYY")}`}</Typography></>
            :
            <><AccessTimeIcon className={classes.expiringClockIcon}/>
            <Typography className={classes.expiringOnText} variant="h6">{`${t('EXPIRING ON')} ${moment(props?.activeItem?.sectionData?.assignedCourseEndDate).format("DD-MMM-YYYY")}`}</Typography></>}
          </Box>
        </Box>
      }
    </Box>
    }

    <Box className={classes.selfLearningtabsDiv}>
      <CTabs
        nav={props?.tabBarList}
        selectedTab={props?.selectedTab}
        handleTabChange={props?.handleTabChange}
        subjectDetail={props?.subjectDetail}
        mySectionData={mySectionData}
        isCourseExpired={props?.isCourseExpired}
        neverExpired={props?.neverExpired}
        isCertCompleted={isCertCompleted}
      />
      <Box className={props?.selectedIndex !== 3 ? classes.selfLearningScroll : undefined}>
      {props?.selectedIndex === 0 && (
        <>
          {mySectionData?.data?.section !== undefined ? mySectionData?.data?.section.map((item, index) => {
            return(<SelfLearningCard key={index} currentActiveSection={currentActiveSection} setCurrentActiveSection={setCurrentActiveSection}
              setActiveItem={props.setActiveItem} activeItem={props?.activeItem} index={index} sectionIndex={index} data={item}
              sectionData={mySectionData} activeIndex={activeIndex} setActiveIndex={setActiveIndex}
              onVideoRefresh={props?.onVideoRefresh} videoRefresh={props?.videoRefresh} pdfOpen={props?.pdfOpen} courseId={props?.activeItem?.sectionData?.data?.courseId?._id}
              onPdfOpen={props.onPdfOpen} 
              courseName={props?.courseName}
              setSectionNumber={props?.setSectionNumber}
              setSectionName={props?.setSectionName}
              setNextClick={props?.setNextClick}
              openPdfViewer={props?.openPdfViewer}
              setCourseDataList={props?.setCourseDataList}
              setSelectedSubmenu={props?.setSelectedSubmenu}
              selectedSubmenu={props?.selectedSubmenu}
              currentSectionIndex = {props?.currentSectionIndex}
              isDropdownOpen={props?.isDropdownOpen}
              setIsDropdownOpen={props?.setIsDropdownOpen}
              setCurrentSectionIndex = {props?.setCurrentSectionIndex}
              currentDataIndex = {props?.currentDataIndex}
              setCurrentDataIndex={props?.setCurrentDataIndex}
              setIsDropDown={props?.setIsDropDown}
              sectionChanged={props.sectionChanged} 
              setSectionChanged={props.setSectionChanged}
              showEvaluationTest={props.showEvaluationTest}
              setShowEvaluationTest={props.setShowEvaluationTest}
              sectionName={props.sectionName}
              handleUpdateCourseProgress={props?.handleUpdateCourseProgress}
              isCourseExpired={props?.isCourseExpired}
              />)
          }) : !isLoadingSelf && mySectionData?.data?.section?.length < 1 && <>{t('No Self Learning data found!')}</>}    
        </>
      )}

      {props?.selectedIndex === 1 && (
        props?.isCourseExpired ? (
          <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', opacity: 0.6 }}>
            <LockIcon style={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '12px' }} />
            <Typography style={{ fontSize: '16px', fontWeight: 500, color: '#616161', textAlign: 'center' }}>{t('This course has expired. Live classes are no longer accessible.')}</Typography>
          </Box>
        ) : (
          <Box>
              {mySectionData?.data?.liveClass?.length ? mySectionData?.data?.liveClass.map((item, index) => {
                return <LiveClassCard key={index} data={item} sectionData={mySectionData} />
              }) : !isLoadingSelf && mySectionData?.data?.section?.length() < 1 && <>{t('No Live Class Found!')}</>}
          </Box>
        )
      )}

      {props?.selectedIndex === 2 && !isLoadingSelf && (
        props?.isCourseExpired ? (
          <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', opacity: 0.6 }}>
            <LockIcon style={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '12px' }} />
            <Typography style={{ fontSize: '16px', fontWeight: 500, color: '#616161', textAlign: 'center' }}>{t('This course has expired. Evaluation tests are no longer accessible.')}</Typography>
          </Box>
        ) : (
          <Box>
              {quiz?.length ? <Box>
                  {quiz?.length ? (
                  <QuizListSection
                      hideViewMore={false}
                      quizSectionList={quiz}
                      showVertical={true}
                      handleRefresh={handleRefresh}
                      startQuiz={startQuiz}
                      course_id={props?.selectedCourseId}
                      onQuizCardClick={props?.onQuizCardClick}
                      showInstructions={props?.showInstructions}
                      showInstructionScreen={props?.showInstructionScreen}
                      progressPercent={mySectionData?.data?.progressPercent}
                      attemptsRemaining={mySectionData?.data?.evaluationTest[0]?.quizAttempts}
                      courseName={props?.courseName}
                      quizTotalAttempts={quizAttemptsCount}
                      certificationToggle={mySectionData?.data?.courseId?.certificationToggle}
                      isUserCertified={isCertCompleted}
                  />
                  ) : (
                  <NoData message={t("no_data")} />
                  )}
              </Box> : !isLoadingSelf && !mySectionData?.data?.evaluationTest && <>{t('No Evaluation Test Found!')}</>}
          </Box>
        )
      )}

      {props?.selectedIndex === 3 && (
        props?.isCourseExpired && !(props?.neverExpired && isCertCompleted) ? (
          <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', opacity: 0.6 }}>
            <LockIcon style={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '12px' }} />
            <Typography style={{ fontSize: '16px', fontWeight: 500, color: '#616161', textAlign: 'center' }}>{t('This course has expired. Certification is no longer accessible.')}</Typography>
          </Box>
        ) : (
          <CertificateCard setdownloadCertificateButton={props?.setdownloadCertificateButton} downloadCertificateButton={props?.downloadCertificateButton} sectionData={mySectionData} />
        )
      )}
      </Box>
    </Box>
      
      {/* Video */}
      {currentVideo?.refModel === "RecordedVideo" && (
        <VideoSelfLearning 
          playerRef={playerRef}
          currentVideo={currentVideo}
          videoPlayback={videoPlayback}
          setVideoPlayback={setVideoPlayback}
          handleVideoPlayback={handleVideoPlayback}
          handleVideoOnReady={handleVideoOnReady}
          videoPlayerControls={videoPlayerControls}
          showPopup={showPopup}
          closePopup={closePopup}
          handleResume={handleResume}
          handleStartFromBeginning={handleStartFromBeginning}
          callProgressApi={callProgressApi}
          isVideoLoaded={isVideoLoaded}
          thumbnail={<SelfLearningImage alt="default-image" style={{ width: "100%" }} />}
        />
      )}
      {/* Quiz Instruction */}
      {currentVideo?.refModel === "Quiz" && (
        <InstructionBlock
          key={currentVideo?.contentData?._id || currentVideo?.contentData?.id || JSON.stringify(currentVideo?.contentData)}
          quiz={currentVideo?.contentData}
          quizIsStarted={quizIsStarted}
          sectionId={props?.sectionId}
          toggleInstructionBox={toggleInstructionBox}
          startQuiz={startQuiz}
          certificateUnlocked={certificateUnlocked}
          setSubmittedTest={setSubmittedTest}
          setShowCourseModalAfterQuiz={props?.setShowCourseModalAfterQuiz}
          coursePercentage={props?.coursePercentage}
          setSuppressCourseModal={props?.setSuppressCourseModal}
          isCourseExpired={props?.isCourseExpired}
          neverExpired={props?.neverExpired}
        />
      )}
    </Box>
  );
}

export default SelfLearningContent;
